import { customElement, property } from 'lit/decorators.js';
import { MediaPlayerBaseComponent } from '../media-player.component';
import { styles } from './audio.styles';
import { baseStyles } from '../media-player.styles';
import { tagName } from '../../../helpers';

const tag = tagName('audio-player');

@customElement(tag)
export class MediaPlayerAudioComponent extends MediaPlayerBaseComponent {
  static override styles = [baseStyles, styles];

  override bbwPlayout = 'basic_msp20_responsive_redesign_for_audio';

  @property({ type: Boolean })
  fixedWidth = false;
}

declare global {
  interface HTMLElementTagNameMap {
    'a-audio-player': MediaPlayerAudioComponent;
  }
}
